import React from "react";
import { Link } from "react-router-dom";
import "../CSS/NotFound.css";
import { IoMdArrowBack } from "react-icons/io";

const PageNotFound = () => {
  return (
    <>
      <div className="page_not_found_wrapper">
        <div className="not_found_content">
          <div className="error_code_container">
            <div className="error_code">404</div>
            <div className="error_line"></div>
          </div>

          <h1 className="error_title">Page Not Found</h1>
          <p className="error_description">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <Link to="/" className="btn primary_button back_home_btn">
            <IoMdArrowBack className="back_icon" />
            <span>Back to Home</span>
          </Link>
        </div>

        <div className="background_decoration">
          <div className="circle circle_1"></div>
          <div className="circle circle_2"></div>
          <div className="circle circle_3"></div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;